import styled from "styled-components";
import { compassLightGreen, lightGreys } from "../../styles";

export interface AccentCardProps {
  /** Left border accent color */
  accentColor?: string;
  /** Use tinted background (accentColor at 30% opacity) instead of KPIBackground */
  tinted?: boolean;
  /** Gap between children (default: 10px) */
  gap?: number;
  /** Padding (default: 8px 12px) */
  padding?: string;
  /** Flex direction (default: row) */
  direction?: "row" | "column";
  /** Min height to prevent layout shift */
  minHeight?: number;
}

/**
 * A card with left accent border - used for SDGs, escalations, descriptions, etc.
 */
export const AccentCard = styled.div<AccentCardProps>`
  background: ${({ tinted, accentColor }): string =>
    tinted ? `${accentColor}30` : lightGreys.KPIBackground};
  border-left: 3px solid
    ${({ accentColor }): string => accentColor ?? compassLightGreen};
  border-radius: 4px;
  padding: ${({ padding }): string => padding ?? "8px 12px"};
  display: flex;
  flex-direction: ${({ direction }): string => direction ?? "row"};
  align-items: ${({ direction }): string =>
    direction === "column" ? "flex-start" : "center"};
  gap: ${({ gap }): number => gap ?? 10}px;
  ${({ minHeight }): string => (minHeight ? `min-height: ${minHeight}px;` : "")}
`;
